<!-- 非结构化数据 -->

<template>
  <div class="page_html">
    <div class="banner">
      <img
        src="@/assets/solution/enterprise/solution_banner.png"
        alt=""
      >
      <div class="banner_Title">
        <div class="title">
          {{ title }}
        </div>
        <div class="subtitle">
          {{ subtitle }}
        </div>
      </div>
    </div>

    <div class="introduce">
      <p class="sub_title">
        非结构化数据主要传播途径
      </p>
      <div class="ways">
        <div
          v-for="item in ways"
          :key="item.id"
          class="way"
        >
          <div
            v-if="!item.hasImg"
            class="left_way"
          >
            {{ item.title }}
          </div>
          <div
            v-if="!item.hasImg"
            class="right_way"
          >
            {{ item.text }}
          </div>
          <div
            v-if="item.hasImg"
            class="hasImg"
          >
            <img
              src="@/assets/solution/constructor/circle.png"
              alt=""
            >
            <div class="imgContent">
              传&nbsp;播途&nbsp;径
            </div>
          </div>
        </div>
      </div>
      <div class="way2">
        <div class="left_way">
          移动存储
        </div>
        <div class="right_way">
          移动存储类介质主要是U盘、移动硬盘等设备，该类设备由于具备拷贝数据、存储数据的功能，非法泄密人员可以很轻松的将重要数据拷贝进设备中，然后将其带出单位，由此引发单位内部数据的外泄。
        </div>
      </div>
    </div>

    <div class="introduce background">
      <p class="sub_title">
        非结构化数据防泄密解决方案
      </p>

      <div class="solutions">
        <div
          v-for="item in solutions"
          :key="item.id"
          class="solution"
        >
          <div class="solution_title">
            {{ item.title }}
          </div>
          <div class="solution_text">
            {{ item.text }}
          </div>
          <span class="index_Number">
            {{ item.number }}
          </span>
        </div>
      </div>
    </div>

    <div class="introduce ">
      <p class="sub_title">
        方案价值
      </p>
      <Lists :values="values" />
    </div>
  </div>
</template>
<script>
import Lists from '@/views/solution/components/lists.vue'

export default {
  name: 'SimpleVersionOfSafeOperation',
  components: {
    Lists
  },
  data() {
    return {
      title: '非结构化数据',
      subtitle: '非结构化数据是指数据结构不规则或不完整，没有预定义的数据模型，不方便用数据库二维逻辑表来表现的数据。包括所有格式的办公文档、文本、图片、XML, HTML、各类报表、图像和音频/视频信息等等。在IT领域有一条著名的理论，那就是“二八原则”，其主要讲的是结构化数据占20%，非结构化数据占80%。由此可见，这是一个非结构化数据的时代，文件数据、对象数据和流数据构成了非结构化数据的主体，也是实施安全保护的重点对象和目标。',
      solutions: [
        {
          id: 1,
          title: '网络外发审计管控',
          text: '部署上网行为管理设备来进行网络访问情况的审计以及过滤，上网行为管理设备可以对用户的各类操作进行管控，支持对终端的应用控制、内容审计与过滤，其中应用控制可以对即时聊天工具、网盘等，内容审计与过滤则是主要对电子邮件收发内容、论坛发帖情况、网页搜索内容等进行审计与过滤。',
          number: '01'
        },
        {
          id: 2,
          title: '文件内容审计过滤',
          text: '部署终端安全管理系统可以对终端设备上文件的各种操作行为进行管控，详细记录文件的整个操作流程。同时可以扫描并发现电脑上的敏感信息分布和不当存储，进行关键词预警，一旦有违规内容，立刻自动采取警告、隔离、甚至阻断等保护动作。针对终端文件的流转进行全面的审计，包含对终端上文件的外发和读写进行审计，实现文档的全流程跟踪和防护，便于事后进行追溯。',
          number: '02'
        },
        {
          id: 3,
          title: '移动存储介质管理',
          text: '终端安全管理系统能够实现对移动存储设备的灵活管控，包括移动存储介质的身份注册、网内终端授权管理、移动介质挂失管理、外出管理和终端设备例外等功能。给予不同的移动存储介质相应的授权范围和密级，同时支持设备状态的追踪与管理。',
          number: '03'
        },
        {
          id: 4,
          title: '屏幕水印技术',
          text: '针对屏幕水印可以将水印文字、显示计算机名、显示用户名、IP地址、MAC地址等数据以半透明的方式呈现在屏幕上。但是对以拍照等方式泄露重要数据形成有效的震慑，直接降低了以拍照方式泄露重要数据的风险。',
          number: '04'
        }
      ],
      values: [
        {
          id: 1,
          title: '协同联动，全面防范文件泄密',
          src: require('@/assets/solution/government/waiguanzidingyi.png'),
          content: '通过联动对终端进行全方位的管控，达到更为全面的互联网访问审计、文件管控，全面防范文件泄密。 '
        },
        {
          id: 2,
          title: '精细化审计网络访问情况',
          src: require('@/assets/solution/government/keshihuaguanli.png'),
          content: '上网行为管理系统提供对通过电子邮件、即时通讯、论坛发帖等途径的外发信息进行监控审计，对违反国家法律、危害社会安全的内容进行过滤，净化网络，减少病毒进入局域网的几率，降低法律风险，创造文明健康的上网环境'
        },
        {
          id: 3,
          title: '移动存储介质安全管理',
          src: require('@/assets/solution/government/gongdanchuli.png'),
          content: '移动存储介质管理针对U盘、移动硬盘等进行安全管控，给予不同的移动存储介质相应的授权范围和密级，同时可以针对设备状态进行追踪与管理。'
        },
        {
          id: 4,
          title: '终端设备安全防护',
          src: require('@/assets/solution/government/chixushengji.png'),
          content: '提供终端杀毒、补丁管理、主机防火墙功能、终端流量管理等安全管理功能。'
        }
      ],
      ways: [
        {
          id: 1,
          title: '应用转发',
          text: '邮件、即时聊天工具、WEB浏览器上传、网盘等，这些应用也极易成为数据泄密的“重灾区”，根据以往的泄密事件来看，大多数泄密的数据都是通过这类应用转发出去的。'
        },
        {
          id: 2,
          hasImg: true
        },
        {
          id: 3,
          title: '屏幕拍照 录屏传播',
          text: '可以通过手机、相机等具备拍摄功能的设备，对屏幕拍照或拍摄视频，将敏感涉密文件记录下来，带出单位后进行后续的传播，从而造成数据外露'
        }

      ]

    }
  }
}
</script>

<style lang="less" scoped>
.page_html {
  height: 100%;

  .banner {
    width: 100wh;
    height: 600px;

    img{
      width: 100%;
      height: 100%;
    }

    .banner_Title {
      position: absolute;
      top: 15%;
      left: 15%;
      width: 80%;

      .title {
        width: 56%;
        font-size: 54px;
        color: #ffffff;
        font-weight: bold;
      }

      .subtitle {
        width: 72%;
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        margin-top: 50px;
      }
    }
  }

  .ways {
    width: 70%;
    margin: 0 auto;
    height: 500px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .way {
      display: flex;

      &:nth-child(3) {
        >.left_way {
          padding: 9px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #57ACFE;

          &::after {
            content: '、';
            line-height: 14px;
          }
        }

        >.right_way {
          background: #E8F7FE;
        }
      }
    }

    img {
      width: 80%;
    }

    .hasImg {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      position: relative;

      .imgContent {
        position: absolute;
        font-size: 40px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        width: 90px;
        top: 70px;

      }
    }

    .left_way {
      word-wrap: break-word;
      width: 67px;
      height: 196px;
      background: #929AD3;
      border-radius: 10px 0px 0px 10px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 30px;
      box-sizing: border-box;
      padding: 26px;
      display: flex;
      flex-direction: column;

    }

    .right_way {
      width: 357px;
      height: 196px;
      background: #F4F6F9;
      border-radius: 10px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      box-sizing: border-box;
      padding: 20px 30px;
    }
  }

  .way2 {
    display: flex;
    width: 70%;
    margin: 0 auto;
    justify-content: center;

    .left_way {
      width: 67px;
      height: 196px;
      background: #3879F6;
      border-radius: 10px 0px 0px 10px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 30px;
      box-sizing: border-box;
      padding: 26px;
      display: flex;
      flex-direction: column;
    }

    .right_way {
      width: 645px;
      height: 196px;
      background: #EBF2FE;
      border-radius: 10px;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      box-sizing: border-box;
      padding: 20px 30px;
      font-size: 18px;
    }
  }

  .solutions {
    width: 70%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    padding-top: 80px;

    >.solution {
      width: 49%;
      height: 290px;
      background: #FFFFFF;
      border-radius: 0px 40px 0px 0px;
      box-shadow: 0 0 10px 5px #D7EDFF;
      position: relative;
      display: flex;
      justify-content: space-evenly;
      flex-direction: column;
      margin-bottom: 80px;

      >.solution_title {
        font-size: 36px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3879F6;
        line-height: 40px;
        padding: 0 30px;

      }

      >.solution_text {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 35px;
        padding: 0 30px;
      }

      .index_Number {
        font-size: 90px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #D2E1FC;
        line-height: 40px;
        position: absolute;
        top: -20px;
        right: -21px;
      }
    }

  }

  .background {
    padding-top: 110px;
    background: #FAFBFF;
  }

}
</style>
